 /*=========================================================================================
  File Name: state.js
  Description: Opening Hours State
  ----------------------------------------------------------------------------------------
  Item Name: Opening Hours State Module
  Author: Tan Tran
==========================================================================================*/
import moment from 'moment'
export default {
    openingHours : [],
    currentLocalTime : moment(),
    disabledHours: [],
    fromTime : moment(),
    toTime : moment()
}